import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import './text-editor.css';

//https://codepen.io/alexkrolick/pen/XgaVVX?editors=0110
//html source button
//https://github.com/zenoamaro/react-quill
class TextEditor extends React.Component{
  constructor (props){
    super(props);
    this.state = { text:props.text, html: props.text, showRaw: false };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeRaw = this.handleChangeRaw.bind(this);
  }

  componentDidMount() {
    const self = this;
    var customButton = document.querySelector('.ql-showHtml');
    customButton.addEventListener('click', function() {
      self.handleClickShowRaw ();
    });
  }

  handleClickShowRaw() {
    const isEditingRaw = this.state.showRaw;
    this.setState({showRaw: !isEditingRaw});
    this.syncViews(isEditingRaw);
  }

  syncViews (isEditingRaw) {

     if (isEditingRaw) this.setState({text: this.state.html})
     else this.setState({html: this.state.text})
  }

  handleChange (html) {
   	this.setState({ text: html, html: html });
    this.props.onChange(html);
  }

  handleChangeRaw(html) {
    this.setState({ html: html  });
  }

  render() {
    return (
      <div className={ this.state.showRaw ? "showRaw" : ""}>
      <ReactQuill
        onChange={this.handleChange}
        value={this.state.text}
        modules={TextEditor.modules}
        formats={TextEditor.formats}
        theme="snow"
      />
      <div className={"raw-editor"}>
        <textarea
                className={"raw-editor--text"}
                onChange={(e) => this.handleChangeRaw(e.target.value)}
                value={this.state.html}
              />
      </div>
      </div>

    );
  }
}

/*
 * Quill modules to attach to editor
 * See https://quilljs.com/docs/modules/ for complete options
 */
TextEditor.modules = {
  toolbar: [
    [{ 'header': '1'}, {'header': '2'}, { 'font': [] }],
    [{size: []}],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{'list': 'ordered'}, {'list': 'bullet'},
     {'indent': '-1'}, {'indent': '+1'}],
    ['image'],
    ['clean'],
    ['showHtml']
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false,
  }
};
/*
 * Quill editor formats
 * See https://quilljs.com/docs/formats/
 */
TextEditor.formats = [
  'header', 'font', 'size',
  'bold', 'italic', 'underline', 'strike', 'blockquote',
  'list', 'bullet', 'indent',
   'image'
];

export default TextEditor;



// WEBPACK FOOTER //
// ./src/components/form/TextEditor.js